import './MessageCloud.scss';

import React, { useMemo } from 'react'
import { ChatMessage } from '../../models/LLM'
import classNames from 'classnames';
import MDEditor from '@uiw/react-md-editor';

type Props = {
  message?: ChatMessage;
  children?: React.ReactNode;
}

export default function MessageCloud({ message, children }: Props) {
  const messageContent = useMemo(() => children || message?.text || "Message", [message, children]);

  return (
    <div className={classNames("message-cloud", { user: message?.isUserPrompt })}>
      {typeof messageContent === 'object'
        ? messageContent
        : (
          <div data-color-mode="light">
            <MDEditor.Markdown className="bg-transparent" source={messageContent} />
          </div>
        )
      }
    </div>
  )
}